import { Box, Typography, Tooltip } from "@mui/material";
// config
import colors from "../../../config/colors";
// utils
import { formatNumberKMB, getAssetUrl } from "../../../utils/helpers";
import {
  ACTION,
  CATEGORY,
  LABEL2,
  PAGE,
  SCREEN,
  triggerGa,
} from "../../../utils/gaUtils";

const Followers = ({ item, viewType = "list" }) => {
  const instaFollowers = item?.insta_followers || 0;
  const ytSubscribers = item?.yt_subscribers || 0;

  const handleInstaClick = (e) => {
    triggerGa({
      category: CATEGORY.USER_INTERACTION,
      action: ACTION.INSTA_CLICK,
      label: item?.username,
      label3: LABEL2.PROFILE_INTEREST,
      page: PAGE.CREATOR_DISCOVER,
      screenName:
        viewType === "card" ? SCREEN.DISCOVER_CARD : SCREEN.DISCOVER_LIST,
    });
    e.stopPropagation();
    window.open(`${item?.profile_link}`, "_blank");
  };

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "row",
        gap: 0.5,
        minWidth: 0,
        flexWrap: "wrap",
      }}
    >
      {instaFollowers > 0 && (
        <Tooltip title={instaFollowers.toLocaleString()} placement="top">
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              gap: 0.5,
              minWidth: 0,
              cursor: "pointer",
            }}
            onClick={handleInstaClick}
          >
            <img
              src={getAssetUrl("Instagram_icon.png")}
              alt="Instagram"
              style={{
                width: 20,
                height: 20,
                flexShrink: 0,
              }}
            />
            <Typography
              fontSize={12}
              fontWeight={500}
              lineHeight="20px"
              noWrap
              sx={{
                minWidth: 0,
                flex: 1,
              }}
            >
              {formatNumberKMB(instaFollowers)}
            </Typography>
          </Box>
        </Tooltip>
      )}

      {/* {ytSubscribers > 0 && (
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            gap: 0.5,
            minWidth: 0,
          }}
        >
          <YouTubeIcon
            sx={{
              width: 20,
              height: 20,
              flexShrink: 0,
              color: colors.gray200,
            }}
          />
          <Typography
            fontSize={12}
            noWrap
            sx={{
              minWidth: 0,
              flex: 1,
            }}
          >
            {formatNumberKMB(ytSubscribers)}
          </Typography>
        </Box>
      )} */}

      {instaFollowers === 0 && (
        <Typography fontSize={12} color={colors.gray200}>
          No followers
        </Typography>
      )}
    </Box>
  );
};

export default Followers;
